<template>
<!-- 选对基本资料 -->
  <div :class="['xd-information',!tips?'on':'']">
      <div v-if="tips" class="tips">
          认真填写资料哦，用于匹配合适的咨询师为您服务
          <img @click="tips=false" src="https://themes-cdn.xjy.cn/statics/career/images/xuandui_gadgets/close-icon.png" alt="">
      </div>
      <!--  -->
      <div class="main">
          <div class="row">
              <label for="">姓名</label>
              <div v-if="!form.name" @click="toFormEdit('姓名')" class="select">
                  请填写<img class="right" src="https://themes-cdn.xjy.cn/statics/career/images/xuandui_gadgets/right-icon.png" alt="">
              </div>
              <div @click="toFormEdit('姓名')" v-else class="text">
                  <div class="t">{{form.name}}</div>
              </div>
          </div>
           <div class="row">
              <label for="">性别</label>
              <div v-if="!form.sex" @click="selectHandle('sex')" class="select">
                  请选择<img class="right" src="https://themes-cdn.xjy.cn/statics/career/images/xuandui_gadgets/right-icon.png" alt="">
              </div>
              <div @click="selectHandle('sex')" v-else class="text">{{form.sex}}
                  <img class="right" src="https://themes-cdn.xjy.cn/statics/career/images/xuandui_gadgets/right-icon.png" alt="">
                </div>
          </div>
           <div class="row">
              <label for="">目前常住城市</label>
              <div v-if="!form.city" @click="selectHandle('city')" class="select">
                  请选择<img class="right" src="https://themes-cdn.xjy.cn/statics/career/images/xuandui_gadgets/right-icon.png" alt="">
              </div>
              <div @click="selectHandle('city')" v-else class="text">{{form.city}}
                  <img class="right" src="https://themes-cdn.xjy.cn/statics/career/images/xuandui_gadgets/right-icon.png" alt="">
              </div>
          </div>
           <div class="row">
              <label for="">学历</label>
              <div v-if="!form.education" @click="selectHandle('education')" class="select">
                  请选择<img class="right" src="https://themes-cdn.xjy.cn/statics/career/images/xuandui_gadgets/right-icon.png" alt="">
              </div>
              <div @click="selectHandle('education')" v-else class="text">{{form.education}}
                  <img class="right" src="https://themes-cdn.xjy.cn/statics/career/images/xuandui_gadgets/right-icon.png" alt="">
              </div>
          </div>
           <div class="row">
              <label for="">大学毕业时间</label>
              <div v-if="!form.gra_date" @click="selectHandle('gra_date')" class="select">
                  请选择<img class="right" src="https://themes-cdn.xjy.cn/statics/career/images/xuandui_gadgets/right-icon.png" alt="">
              </div>
              <div @click="selectHandle('gra_date')" v-else class="text">{{form.gra_date}}
                  <img class="right" src="https://themes-cdn.xjy.cn/statics/career/images/xuandui_gadgets/right-icon.png" alt="">
              </div>
          </div>
           <div class="row">
              <label for="">目前工作状态</label>
              <div v-if="!form.work_status" @click="selectHandle('work_status')" class="select">
                  请选择<img class="right" src="https://themes-cdn.xjy.cn/statics/career/images/xuandui_gadgets/right-icon.png" alt="">
              </div>
              <div @click="selectHandle('work_status')" v-else class="text">{{form.work_status}}
                  <img class="right" src="https://themes-cdn.xjy.cn/statics/career/images/xuandui_gadgets/right-icon.png" alt="">
              </div>
          </div>
           <div class="row">
              <label for="">问题描述</label>
              <div v-if="!form.problem" @click="toFormEdit('描述问题')" class="select">
                  请简单描述问题<img class="right" src="https://themes-cdn.xjy.cn/statics/career/images/xuandui_gadgets/right-icon.png" alt="">
              </div>
              <div @click="toFormEdit('描述问题')" v-else class="text">
                  <div class="t">{{form.problem}}</div>
                  <img class="right" src="https://themes-cdn.xjy.cn/statics/career/images/xuandui_gadgets/right-icon.png" alt="">
              </div>
          </div>
      </div>
       <!--  -->
      <div class="footer">
          <button @click="saveHandle()">提交资料</button>
      </div>
      <!-- 弹出信息 -->
      <van-popup v-model="popShow" position="bottom"   @close="pickerShowClick(false)" >
          
          <van-area v-if="picker_type=='city'" :area-list="columns" :columns-num="2"  @cancel="popShow=false" @confirm="cityCfm" />
          <van-picker v-else show-toolbar :columns="columns" @confirm="cityCfm" @cancel="popShow=false" />
      </van-popup>
  </div>
</template>

<script>
import { orderList,saveInfo } from "@/api/xuandui_gadgets"
import { getStorage, setStorage, deleteStorage} from '@/utils/tools'
import areaList from "@/utils/area";
import { shareCon } from "@/utils/wxconfig";
export default {
    data(){
        return{
            tips:true,
            keys:{
                name:'姓名',
                sex:'性别',
                city:'目前常住城市',
                education:'学历',
                gra_date:'大学毕业时间',
                work_status:'目前工作状态',
                problem:'问题描述',
            },
            form:{
                name:'',
                sex:'',
                city:'',
                education:'',
                gra_date:'',
                work_status:'',
                problem:''
            },
            // 弹出信息
            popShow:false,
            // 弹出类型
            picker_type:'sex',
            popObj:{
                sex:['男','女'],// 性别
                city:areaList,// 常驻城市
                education:['初中及以下','中专/中技','高中','大专','本科','硕士','博士'],// 学历
                gra_date:[],// 毕业时间
                work_status:['离职','在职','在读'],// 工作状态
            },
            list:[],
            pages:{
                page: 1,
                size: 10,
            },
            columns:[]

        }
    },
    methods:{
        /*
        *@Description: vue中mini-ui或vant popup与picker结合在iphone手机穿透问题
        *@MethodAuthor:  Zhang Xiao Guang
        *@Date: 2019-11-28 12:18:35
        */
        pickerShowClick(newval) {
            let self = this;
            if (newval) {
            document.getElementsByTagName("body")[0].addEventListener('touchmove', self.preventDefault, {
                passive: false
            }); //阻止默认事件
            } else {

            document.getElementsByTagName("body")[0].removeEventListener('touchmove', self.preventDefault, {
                passive: false
            }); //打开默认事件
            }
        },
        // 提交资料
        saveHandle(){
            let fild = Object.keys(this.form);
            let arr = [];
            fild.map(v=>{
                if(!this.form[v]){
                    this.$toast('信息不能为空！');
                    return
                }
                arr.push({
                    label:this.keys[v],
                    value:this.form[v]
                });
            });
            saveInfo({
                order_id:this.list[0].id,
                information:JSON.stringify(arr)
            }).then((data)=>{
                if(data.error>0){
                    this.$toast(data.detail || data.msg);
                    return
                }
                this.$toast('保存成功！');
                this.$router.go(-1);
            });
        },
        // 确认选择城市触发
        cityCfm(picker) {
            // 判断是否是城市类型
            if(this.picker_type=='city'){
                this.form[this.picker_type] = picker[0].name+'/'+ picker[1].name;
                // 如果是数组的话
            }else if(picker instanceof Array){
                this.form[this.picker_type] = picker[0]+'/'+ picker[1];
            }else{
                this.form[this.picker_type] = picker;
            }
            this.popShow = false;
        },
        // 触发弹出
        // type 弹出选择类型
        selectHandle(type){
            // 赋值类型
            this.picker_type = type;
            // 赋值选择数组
            this.columns = this.popObj[type];
            this.popShow = true;

        },
        // 跳转填写表单信息
        toFormEdit(val){
            this.$router.push({
                path:'/xd_info_form',
                query:{
                    title:val
                }
            });
        },

        // 初始化获取数据
        pullData(){
            //调用加载中
            this.$emit('loadingHandle',true,"拼命加载中...");
            let q = this.$route.query;
            let obj = {
                page:this.pages.page,  //页码，默认1
                size:this.pages.size,   //每页数量，默认10
                category_id:2,//做自己节传1,选对小工具传2
                status:1,
                id:q.oid
            };
            orderList(obj).then((data)=>{
                    //关闭加载中
                this.$emit('loadingHandle',false);
                if(data.error>0){
                    this.$toast(data.detail || data.msg);
                    return
                }
                this.pages = data.pager;
                
                this.list = data.list;
                
                let info = JSON.parse(this.list[0].information)?JSON.parse(this.list[0].information):[];
                let name = getStorage('/xd_information','name');
                let problem = getStorage('/xd_information','problem');
                let keys_ = Object.keys(this.keys);
                info.map((v,idx)=>{
                    keys_.map((k,kidx)=>{
                        if(v.label==this.keys[k]){
                            this.form[k] = v.value;
                        }
                    });
                });
                if(!this.form.name){
                    this.form.name = name;
                } 
                if(!this.form.problem){
                    this.form.problem = problem;
                }

                document.title = '基本信息';

                // 处理年份数据
                if(this.popObj.gra_date.length<=0){
                    let date = new Date();
                    let yesr_ = date.getFullYear(); //获取完整的年份(4位)
                    let arr = [];
                    for(let i=yesr_;i>=1900;i--){
                        arr.push(i);
                    }
                    
                    this.popObj.gra_date = [// 第一列 年份
                        {
                            values: arr,
                            defaultIndex: 2,
                        },
                        // 第二列 月份
                        {
                            values: [1,2,3,4,5,6,7,8,9,10,11,12],
                            defaultIndex: 1,
                        }
                    ];
                }
            });

            

            shareCon('index',this);
        }
    },
    created(){
        this.pullData();
    }
}
</script>
<style lang="scss">
    body{
        background-color: #F7F8F9;
    }
</style>
<style lang="scss" scoped>
.xd-information{
    position: relative;
    padding: 92px 30px 140px;
    .tips{
        position: fixed;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 100%;
        max-width: 750px;
        height: 72px;
        display: flex;
        align-items: center;
        padding: 0 30px;
        font-size: 22px;
        color: #FF9000;
        background-color: #FFE9CC;
        font-weight: 400;
        color: #FF9000;
        img{
            width: 24px;
            height: 24px;
            margin-left: auto;
        }
    }
    .main{
        background: #FFFFFF;
        border-radius: 20px;
        padding: 30px;
        overflow: hidden;
        .row{
            display: flex;
            align-items: center;
            height: 98px;
            label{
                font-size: 28px;
                color: #7D8289;
                font-weight: 400;
                margin-right: auto;
            }
            .select{
                display: flex;
                align-items: center;
                font-size: 24px;
                color:#A9AFB3;
                .right{
                    width: 24px;
                    height: 24px;
                    margin-left: 10px;
                }
            }
            .text{
                font-size: 30px;
                font-weight: 500;
                color: #2B333A;
                line-height: 46px;
                display: flex;
                align-items: center;
                .t{
                    width: 404px;
                    text-align: right;
                }
                img{
                    margin-left: 10px;
                }
            }
        }
    }
    .footer{
        height: 120px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: fixed;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 100%;
        max-width: 750px;
        background-color: #FFFFFF;
        button{
            width: 670px;
            height: 80px;
            background: #46A3FA;
            border-radius: 40px;
            font-size: 32px;
            font-weight: 500;
            color: #FFFFFF;
            line-height: 44px;
            letter-spacing: 1px;
            border: none;
        }
    }
}
.xd-information.on{
    padding-top: 20px;
}
</style>